
  var _styles = {
  "coupon-card-triple": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.21333rem",
    "marginBottom": "0.32rem",
    "marginRight": "0.16rem",
    "overflow": "hidden"
  },
  "info-section": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "marginTop": "0.26667rem"
  },
  "amount-section-triple": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginTop": "-0.04rem"
  },
  "expire-time-wrapper-triple": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "expire-time-triple": {
    "fontSize": "0.24rem",
    "lineHeight": "0.42667rem",
    "color": "rgb(153,153,153)"
  },
  "button-wrapper-triple": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "paddingTop": "0.08rem",
    "paddingRight": "0.21333rem",
    "paddingBottom": "0.08rem",
    "paddingLeft": "0.21333rem",
    "borderRadius": "0.64rem",
    "marginTop": "0.05333rem"
  },
  "button-wrapper-triplecan-draw": {
    "backgroundColor": "rgb(255,59,48)"
  },
  "button-wrapper-triplecannot-draw": {
    "backgroundColor": "rgb(204,204,204)"
  },
  "button-text-triple": {
    "fontSize": "0.29333rem",
    "lineHeight": "0.53333rem",
    "color": "rgb(255,255,255)",
    "fontWeight": "500"
  }
};



  module.exports = _styles;
  